import { generatePath, useParams } from "react-router";
import { ReportDetails } from "@sscs/types";
import { FULL_REPORT_PATH } from "Constants";
import { generateReportSearchParams } from "Utils";

const useReportNavigation = ({
  projectName,
  packageName,
  version,
  isRepro,
  diffWith,
  riskCategory,
  riskViolations,
  componentPath,
}: ReportDetails): {
  reportLink: string;
  searchParams: string;
} => {
  const { groupId } = useParams();
  const path = generatePath(`/${FULL_REPORT_PATH}`, {
    // placeholder in case components rerender when there is no groupId in URL
    // (double click on file stream navigation tab for example)
    groupId: groupId ?? "placeholder",
    projectName: projectName,
    packageName: packageName,
    version: version,
  });
  const searchParams = generateReportSearchParams({
    isRepro,
    diffWith,
    riskCategory,
    riskViolations,
    componentPath,
  });
  const reportLink = `${path}`;

  return { reportLink, searchParams: searchParams.toString() };
};

export default useReportNavigation;
